import * as React from 'react';
export const IcPlayPause = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.27 10.52L5 5.69a1.86 1.86 0 00-3 1.48v9.66a1.86 1.86 0 003 1.48l6.27-4.83a1.87 1.87 0 000-2.96zM15.5 6A1.5 1.5 0 0014 7.5v9a1.5 1.5 0 003 0v-9A1.5 1.5 0 0015.5 6zm5 0A1.5 1.5 0 0019 7.5v9a1.5 1.5 0 003 0v-9A1.5 1.5 0 0020.5 6z'
      fill='currentColor'
    />
  </svg>
);
